import { Grid } from "@mui/material";

import { becomeDealerData } from "@/utils/staticData/aboutUsData";
import BecomeDealerCard from "./BecomeDealerCard";

const BecomeDealerShowcase = () => {
  return (
    <Grid container spacing={{ xs: 1, md: 3 }}>
      {becomeDealerData.map(({ title, subTitle, iconUrl, type }, index) => (
        <Grid item xs={4} key={index}>
          <BecomeDealerCard
            title={title}
            subtitle={subTitle}
            iconUrl={iconUrl}
            type={type}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default BecomeDealerShowcase;
